module.exports = __webpack_public_path__ + "img/hz_lc_img.86380cf7.gif";